export default __webpack_public_path__ + "static/media/Hair_20_F_C2.48968433.svg";